import {Box, Divider, Grid, Typography} from '@mui/material';
import {AppButton} from 'components/buttons';
import {CircularLoader} from 'components/Theme';
import {useGetLogsByObjectIdAndObjectType} from 'hooks';
import {
    LogDetailResponse,
    LOGS_CONFIG_ENUM,
    LOGS_OBJECT_TYPE,
    ModifiedItemStatusForItemDataLogModel,
} from 'models/logs';
import React, {useCallback, useEffect, useState} from 'react';
import {LogsCard} from 'views/logs';
import {ReminderDrawerSkeleton} from 'views/reminder';

interface ItemDrawerLogsProps {
    itemDataId?: string;
}
export const ItemDrawerLogs: React.FC<ItemDrawerLogsProps> = ({itemDataId}) => {
    const [logs, setLogs] = useState<LogDetailResponse<ModifiedItemStatusForItemDataLogModel>[]>([]);
    const {
        getAllLogs,
        logsByObjectIdAndObjectTypeLoading: loading,
        logsByObjectIdAndObjectTypeResponse,
    } = useGetLogsByObjectIdAndObjectType<ModifiedItemStatusForItemDataLogModel>();

    useEffect(() => {
        if (itemDataId) {
            getAllLogs({
                variables: {
                    objectId: itemDataId,
                    objectType: LOGS_OBJECT_TYPE.ITEM_DATA,
                    type: LOGS_CONFIG_ENUM.BOARDITEMDATA_UPDATE_STATUSCHANGE,
                    first: 3,
                },
            });
        }
    }, [itemDataId]);
    const appendLogsDataUnique = useCallback((value: LogDetailResponse<ModifiedItemStatusForItemDataLogModel>[]) => {
        setLogs(prev => {
            if (prev) {
                return [...prev, ...value];
            }
            return value;
        });
    }, []);

    const handleNext = () => {
        if (itemDataId) {
            getAllLogs({
                variables: {
                    objectId: itemDataId,
                    objectType: LOGS_OBJECT_TYPE.ITEM_DATA,
                    type: LOGS_CONFIG_ENUM.BOARDITEMDATA_UPDATE_STATUSCHANGE,
                    first: 3,
                    after: logsByObjectIdAndObjectTypeResponse?.pageInfo.endCursor,
                },
            });
        }
    };
    useEffect(() => {
        if (logsByObjectIdAndObjectTypeResponse && logsByObjectIdAndObjectTypeResponse) {
            appendLogsDataUnique(logsByObjectIdAndObjectTypeResponse.nodes);
        }
    }, [logsByObjectIdAndObjectTypeResponse]);

    if (loading && !logsByObjectIdAndObjectTypeResponse) {
        return <CircularLoader />;
    }
    return (
        <Grid container>
            <Grid item xs={12} id={'History'} pt={2}>
                <Box display={'flex'} alignItems={'end'}>
                    <Typography variant="h5">History</Typography>
                </Box>
                <Divider
                    sx={{
                        my: 1,
                        borderStyle: 'dotted',
                        borderColor: 'tertiary.main',
                        borderWidth: '1px',
                    }}
                />
            </Grid>
            <Grid item xs={12}>
                {logs && logs.length === 0 && <Typography>No Logs to show!</Typography>}
                {loading && !logsByObjectIdAndObjectTypeResponse ? (
                    <ReminderDrawerSkeleton />
                ) : (
                    <Grid container spacing={2}>
                        {logs.length > 0 &&
                            logs.map((log, index) => {
                                return <LogsCard log={log} key={`${log.id}${index ?? 0}`} />;
                            })}
                        {logsByObjectIdAndObjectTypeResponse?.pageInfo.hasNextPage && (
                            <Grid item xs={12}>
                                <AppButton onClick={handleNext} fullWidth color="primary" size="small">
                                    Load More
                                </AppButton>
                            </Grid>
                        )}
                    </Grid>
                )}
            </Grid>
        </Grid>
    );
};

export default ItemDrawerLogs;
